import { render, staticRenderFns } from "./UETable.vue?vue&type=template&id=114783d4&scoped=true&"
import script from "./UETable.vue?vue&type=script&lang=js&"
export * from "./UETable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114783d4",
  null
  
)

export default component.exports